export default __webpack_public_path__ + "static/media/480_business06-it-web.3b569ad0.png";